module.exports = __webpack_public_path__ + "static/media/21ECLAC36.a9b4e545.jpg";